import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import store from '../store'
import _ from 'lodash'
import { FIREBASE_CONFIG, GUID, TOKEN_URL, URL } from '../const'

import {
  // RESET_CHATLIST,
  FETCHING_CHATLIST,
  FETCH_CHATLIST_SUCCESS,
  // FETCH_CHATLIST_FAIL,
  FILTER_CHATLIST,
  FETCHING_CHAT,
  FETCH_CHAT_SUCCESS,
  FETCH_ROOM_SUCCESS,
  // FETCH_CHAT_FAIL,
  // POST_MESSAGE,
  FETCH_WAITING_SUPPORT_COUNT,
  RESET_CHAT
} from './types'

firebase.initializeApp(FIREBASE_CONFIG)

// Connect to Firebase
const connectFirebase = async (callback) => {
  // console.log('url: ', TOKEN_URL)
  // console.log('config: ', FIREBASE_CONFIG)
  const url = `${TOKEN_URL}generate_fire_token`
  const config = {
    headers: {
      'Authorization': `Token ${store.getState().user.token}`
    }
  }

  const data = { 'user_id': `staff:${Number(store.getState().user.owner_id)}` }
  try {
    const getToken = await axios.post(
      url,
      data,
      config
    )
    const token = getToken.data.firebase_token
    // console.log('fire token: ', token)
    firebase.auth().signInWithCustomToken(token).catch((error) => {
      // Handle Errors here.
      var errorCode = error.code
      var errorMessage = error.message
      console.log('error', errorCode, errorMessage)
    })

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        callback(user.uid)
      }
    })
  } catch (error) {
    console.log('token error: ', error)
  }
}

export const fetchChatList = (params) => async dispatch => {
  dispatch({ type: FETCHING_CHATLIST })

  const fetchList = () => {
    const userId = firebase.auth().currentUser.uid
    const id = userId.split(':')[1]
    const roomsDB = firebase.database().ref('chat/room-info/')
    roomsDB.on('value', (snapshot) => {
      let ownRooms = {}
      let filtered = {}
      _.map(snapshot.val(), (item, key) => {
        if (key.indexOf(`_${id}`) > 0) {
          item.key = key
          ownRooms[key] = item
        }
      })

      if (params) {
        const { category, categoryID } = params
        switch (category) {
          case 'owner':
            _.forEach(ownRooms, (item, key) => {
              if (key.indexOf(`_${categoryID}`) > 0) {
                filtered[key] = item
              }
            })
            break
          case 'property':
            _.forEach(ownRooms, (item, key) => {
              if (item.propertyID === Number(categoryID)) {
                filtered[key] = item
              }
            })
            break
          case 'resident':
            _.forEach(ownRooms, (item, key) => {
              if (key.indexOf(`user:${categoryID}_`) >= 0) {
                filtered[key] = item
              }
            })
            break
          default:
            filtered = ownRooms
            break
        }
      } else {
        filtered = ownRooms
      }
      dispatch({
        type: FETCH_CHATLIST_SUCCESS,
        payload: filtered
      })
    })
  }
  connectFirebase(fetchList)
}

// Connect to firebase and get the data from a room
export const fetchChat = (id) => async dispatch => {
  dispatch({ type: FETCHING_CHAT })
  const fetchMessages = (user) => {
    const messagesDB = firebase.database().ref(`chat/room-messages/${id}`)
    messagesDB.on('value', (snapshot) => {
      // console.log('snap:', snapshot.val())
      dispatch({
        type: FETCH_CHAT_SUCCESS,
        payload: {
          messages: snapshot.val(),
          userId: user
        }
      })
      // let newMessages = []
      // snapshot.forEach(child => {
      //   const message = child.val()
      //   newMessages.push({ id: child.key, message: message.message })
      // })
      // console.log('new messages: ', newMessages)
    })
  }
  const fetchRoomInfo = () => {
    const messagesDB = firebase.database().ref(`chat/room-info/${id}`)
    messagesDB.on('value', (snapshot) => {
      dispatch({
        type: FETCH_ROOM_SUCCESS,
        payload: snapshot.val()
      })
    })
  }
  connectFirebase(fetchRoomInfo)
  connectFirebase(fetchMessages)
}

const sendNotification = async (roomID, message) => {
  const url = `${URL}chat_notification`
  const config = {
    headers: {
      'Authorization': `Token ${store.getState().user.token}`
    }
  }
  const regExp = /user:(\d+)_/g
  const resident_id = Number(regExp.exec(roomID)[1])
  const body = message ? message.substring(0, 44) : '画像が送信されました。'
  const notificationData = {
    resident_id,
    title: store.getState().user.name,
    body
  }
  // console.log('notification data: ', notificationData)
  try {
    // console.log('post notification')
    await axios.post(
      url,
      notificationData,
      config
    )
    // console.log('res: ', res)
  } catch (error) {
    console.log('error while sending notification. ', error)
  }
}

export const postChatImage = (file, roomID) => async () => {
  const postImage = () => {
    const userId = firebase.auth().currentUser.uid
    const timestamp = new Date().valueOf()
    const fileType = file.type.split('/')[1]
    const fileName = `${timestamp}_${GUID()}.${fileType}`
    const metadata = {
      contentType: file.type
    }
    // console.log('filename: ', fileName)
    const storageDB = firebase.storage().ref(`/images/${fileName}`)
    const uploadTask = storageDB.put(file, metadata)
    uploadTask.on('state_changed', function (snapshot) {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      console.log('Upload is ' + progress + '% done')
      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused')
          break
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running')
          break
        default:
          break
      }
    }, function (error) {
      // Handle unsuccessful uploads
      console.log('error: ', error)
    }, function () {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        // console.log('File available at', downloadURL)
        const messagesDB = firebase.database().ref(`chat/room-messages/${roomID}`)
        messagesDB
          .push({
            type: 'image',
            message: '',
            image: downloadURL,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
            userId
          }, function (error) {
            if (error) {
              console.log('an error occured')
            } else {
              sendNotification(roomID)
            }
          })
        const roomsDB = firebase.database().ref(`chat/room-info/${roomID}`)
        roomsDB
          .update({
            read: false,
            waiting_support: false,
            support_completed: false
          })
      })
    })
  }
  connectFirebase(postImage)
}

export const postChatMessage = (data, roomID) => async () => {
  const postMessage = () => {
    // console.log('posting message...', data)
    const userId = firebase.auth().currentUser.uid
    // console.log('userID: ', userId)
    const messagesDB = firebase.database().ref(`chat/room-messages/${roomID}`)
    messagesDB
      .push({
        type: data.type,
        message: data.message,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        userId
      }, function (error) {
        if (error) {
          console.log('an error occured')
        } else {
          sendNotification(roomID, data.message)
        }
      })

    const roomsDB = firebase.database().ref(`chat/room-info/${roomID}`)
    roomsDB
      .update({
        read: false,
        waiting_support: false,
        support_completed: false
      })
  }
  connectFirebase(postMessage)
}

export const filterChat = (filter) => {
  return {
    type: FILTER_CHATLIST,
    payload: filter
  }
}

export const resetActiveChat = () => {
  return {
    type: RESET_CHAT
  }
}

export const setSupportStatus = (roomID) => async dispatch => {
  const setSupport = () => {
    const roomsDB = firebase.database().ref(`chat/room-info/${roomID}`)
    roomsDB
      .update({
        support_completed: true,
        waiting_support: false
      })
  }
  connectFirebase(setSupport)
}

export const fetchWaitingCount = () => async dispatch => {
  const fetchCount = () => {
    const userId = firebase.auth().currentUser.uid
    const id = userId.split(':')[1]
    const roomsDB = firebase.database().ref('chat/room-info/')
    roomsDB.on('value', (snapshot) => {
      let count = 0
      _.map(snapshot.val(), (item, key) => {
        if (key.indexOf(`_${id}`) > 0) {
          if (item.waiting_support) {
            count += 1
          }
        }
      })

      dispatch({
        type: FETCH_WAITING_SUPPORT_COUNT,
        payload: count
      })
    })
  }
  connectFirebase(fetchCount)
}



// WEBPACK FOOTER //
// ./src/actions/chatActions.js